import React from "react";
import { getEmptyRuleDefinition } from "../Testing/TestDataSetup";
import { getEmptyDataDefinition, getFilledDataDefinition } from "../../../rule-engine-core/Common/Data/DataTestData";
import { NumberDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/NumberDataDefinition";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { TreeRuleBuilder } from "../TreeRuleBuilder";

export const TreeRuleStories = [
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = getEmptyDataDefinition();

            return <TreeRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Tree Rule",
        "Empty Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = () => {
                return getFilledDataDefinition();
            };

            return <TreeRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Tree Rule",
        "Read Only Input Data",
    ),
    new StoryNode(
        () => {
            let ruleDefinition = getEmptyRuleDefinition();
            ruleDefinition.inputData = () => {
                return getFilledDataDefinition();
            };
            ruleDefinition.executionResult = () => {
                return new NumberDataDefinition("result");
            };

            return <TreeRuleBuilder ruleDefinition={ruleDefinition} />;
        },
        "Rule Builder",
        "Tree Rule",
        "Read Only Output Data",
    ),
];
